import REGIONS from "@/lib/regions.json";

export const STATES = ["NSW", "VIC", "QLD", "WA", "SA", "TAS", "NT", "ACT"];
export const regionsIn = (state, area) => REGIONS.filter((r) => r.state === state && (!area || r.area === area));
export const areasIn = (state) => [...new Set(REGIONS.filter((r) => r.state === state).map((r) => r.area))];
export const findRegion = (name) => REGIONS.find((r) => r.name === name);

const SEL = "w-full appearance-none bg-black border border-white/15 focus:border-[#FF6A00] focus:outline-none px-3 py-3 text-white";

// State → area (metro / "outside greater …") → region. Stores the region as "Inner West, NSW".
export default function RegionSelect({ value, onChange, testid = "region", labelClass = "form-label", allowAny = false, anyLabel = "Anywhere" }) {
  const cur = findRegion(value);
  const state = cur?.state || "";
  const area = cur?.area || "";
  const pending = String(value || "").startsWith("__") ? value.slice(2).split("|") : null;
  const pState = pending ? pending[0] : state;
  const pArea = pending ? pending[1] : area;
  const pickState = (s) => { const first = areasIn(s)[0]; onChange(s ? `__${s}|${first}` : ""); };
  const pickArea = (a) => onChange(`__${pState}|${a}`);
  const list = regionsIn(pState, pArea);
  return (
    <div className="space-y-3" data-testid={`${testid}-select`}>
      <div className="grid grid-cols-2 gap-3">
        <div>
          <label className={labelClass}>State</label>
          <select value={pState} onChange={(e) => pickState(e.target.value)} className={SEL} data-testid={`${testid}-state`}>
            <option value="">{allowAny ? anyLabel : "Pick a state…"}</option>
            {STATES.map((s) => <option key={s} value={s}>{s}</option>)}
          </select>
        </div>
        <div>
          <label className={labelClass}>Area</label>
          <select value={pArea} onChange={(e) => pickArea(e.target.value)} disabled={!pState} className={`${SEL} disabled:opacity-40`} data-testid={`${testid}-area`}>
            {!pState && <option value="">—</option>}
            {areasIn(pState).map((a) => <option key={a} value={a}>{a.startsWith("Greater") || a === "Canberra" ? a : `Outside the city — ${a}`}</option>)}
          </select>
        </div>
      </div>
      <div>
        <label className={labelClass}>Region</label>
        <select value={cur ? value : ""} onChange={(e) => onChange(e.target.value)} disabled={!pState} className={`${SEL} disabled:opacity-40`} data-testid={`${testid}-region`}>
          <option value="">{pState ? "Pick your region…" : "Pick a state first"}</option>
          {list.map((r) => <option key={r.name} value={r.name}>{r.region}</option>)}
        </select>
      </div>
      {pState && <p className="text-xs text-zinc-500">Can't see your exact spot? Pick the closest region — work matches within 50 km of it.</p>}
    </div>
  );
}
